import {getChampionships} from "../../../data/data";
import {useParams} from "react-router-dom";
import {useMemo} from "react";
import {ChampionshipPerson} from "./ChampionshipPerson";
import {ChampionshipClub} from "./ChampionshipClub";

const championships = getChampionships();

export const Championship = () => {
    const params = useParams();
    const id = params.id;
    const championship = useMemo(() => championships.find(c => c.id === id), [id]);

    return <>
        {
            championship.type === 0 && <ChampionshipPerson/>
        }
        {
            championship.type === 1 && <ChampionshipClub/>
        }
    </>
}